<template>
  <div class="title__container white-back-container">
    <div class="white-back-container__content">
      <div class="white-back-container__inner-content">
        <div class="flow-line__container">
          <FlowLineThreeSteps :steps="threeSteps" :active-step="1" />
        </div>
        <div class="header-text__container">
          <h2 class="headline">お届け先入力</h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlowLineThreeSteps from '../../../../atoms/flow_lines/FlowLineThreeSteps.vue'
export default {
  components: { FlowLineThreeSteps },
  data() {
    return {
      threeSteps: ['入力', '確認', '完了']
    }
  }
}
</script>
